import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2890d0b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "(英訳)-最初は正しい英文になっています。意図的な誤りを加えてからレビューボタンを押してください。", -1))
const _hoisted_2 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("p", null, "(日本文) " + _toDisplayString(_ctx.japanese), 1),
    _hoisted_1,
    _createVNode(_component_v_textarea, {
      modelValue: _ctx.english,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.english) = $event)),
      rows: "3"
    }, null, 8, ["modelValue"]),
    _createVNode(_component_v_btn, {
      onClick: _ctx.review,
      color: "primary"
    }, {
      default: _withCtx(() => [
        _createTextVNode("レビュー")
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createElementVNode("p", null, _toDisplayString(_ctx.current_fragment), 1),
    _createElementVNode("div", {
      innerHTML: _ctx.result_review,
      class: "review"
    }, null, 8, _hoisted_2)
  ], 64))
}